
import Vue from "vue";
import { dispatch } from "@/store";
import { url } from "@/api";

export default Vue.extend({
  mounted() {
    dispatch.appRefreshToken().then((refreshed) => {
      if (refreshed) {
        const { redirect } = this.$route.query;
        window.location.href = redirect
          ? redirect.toString()
          : url.officialWebsite;
      } else {
        window.location.href = "/";
      }
    });
  },
});
